module.exports = "/static/media/error-character.5c5f776a.svg";